import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import type { CommunicationDirection } from "@/api/communications";
import { cn } from "@/design-system/lib/utils";

interface Props {
  direction: CommunicationDirection | null;
  size?: number;
  className?: string;
}

export function DirectionArrow({ direction, size = 14, className }: Props) {
  if (!direction) {
    return <span className={cn("text-gray-mid", className)} aria-hidden>—</span>;
  }
  const Icon = direction === "Inbound" ? ArrowDownLeft : ArrowUpRight;
  const tone =
    direction === "Inbound" ? "text-status-info" : "text-gold-shadow";
  return (
    <Icon
      size={size}
      strokeWidth={1.75}
      className={cn(tone, className)}
      aria-label={direction}
    />
  );
}
